import { MimshakData, defaultEmptyMimshakData } from "./mimshakData";

export enum ManualProductType {
  PURE_SAVINGS_POLICY = 5,
  REAL_ESTATE = 100,
  BANK_ACCOUNT = 200,
  BANK_ACCOUNT_FOREIGN = 201,
  DEPOSIT = 250,
  EMPLOYEE_COMPENSATION = 300,
  MYBANK = 400,
  ALTERNATIVE_INVESTMENTS = 500,
  INVESTMENT_PORTFOLIO = 600,
  LOAN = 800,
  MORTGAGE = 900,
  DISPOSABLE_INCOME = 1000,
  DISPOSABLE_INCOME_ANNUAL = 1001,
  OTHER = 700
}

// ערכי adjusted_product_type נומריים לרשומות ידניות עם סוג-תת
export enum ManualDepositAdjustedType {
  DEPOSIT_MAKAM = 2501,
  DEPOSIT_FOREIGN = 2502,
  STRUCTURED_DEPOSIT = 2503,
  BANK_SAVINGS_PLAN = 2504,
  MONEY_MARKET_FUND = 2505,
  MAKAM = 2506,
  GOVT_BOND = 2507,
  CORPORATE_BOND = 2508,
  OTHER = 2509,
}

export enum ManualRealEstateAdjustedType {
  RESIDENTIAL = 1001,
  INVESTMENT = 1002,
  ABROAD = 1003,
}

export enum ManualEmployeeCompensationAdjustedType {
  RSU = 3001,
  STOCK = 3002,
  OTHER = 3003,
}

export enum ManualAlternativeInvestmentAdjustedType {
  CRYPTO         = 5001,
  COMMODITY      = 5002,
  PRIVATE_EQUITY = 5003,
  HEDGE_FUND     = 5004,
  SOCIAL_LENDING = 5005,
  OTHER          = 5006,
}

export enum ManualInvestmentPortfolioAdjustedType {
  SELF_MANAGED = 6001,
  MANAGED = 6002,
}

export enum ManualDisposableIncomeAdjustedType {
  MONTHLY = 10001,
  GRANT = 10002,
}

export enum ManualDisposableIncomeAnnualAdjustedType {
  ANNUAL = 10011,
  ANNUAL_BONUS = 10012,
  GRANT = 10013,
}

export interface ManualMimshakData extends MimshakData {
  actualiation_date?: string | null;
  is_family?: boolean | null;
}

export const defaultEmptyManualMimshakData = (userId: number): Omit<ManualMimshakData, 'id'> => ({
  ...defaultEmptyMimshakData(userId)
});
